import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import {
  AIChatHistory,
  AIChatItem,
  AIChatMessageItem,
  AIChatMessageItemWithMetadata,
  AiGuestSummaryResponse,
  AISuggestionRequestPayload,
} from './model'
import { delay, map } from 'rxjs/operators'
import * as lodash from 'lodash'
import { Observable, of } from 'rxjs'

@Injectable()
export class AIService {
  constructor(private http: HttpClient) {}

  speech(text: string) {
    return this.http.post<{ buffer: any }>(`@api/ai/advance/speech/`, { text })
  }

  transcript(blob: Blob) {
    const formData = new FormData()
    const filename = 'audio.wav'
    formData.append('file', new Blob([blob], { type: 'audio/wav' }), filename)
    return this.http
      .post<{ [filename]: { response: { text: string } } }>(`@api/ai/advance/transcript/`, formData)
      .pipe(map((res) => res[filename].response))
  }

  chat(messages: AIChatMessageItem[], chatId?: string, format?: 'html' | 'markdown') {
    const payload = {
      id: chatId,
      messages,
      convert: format,
    }
    if (!chatId) {
      delete payload.id
    }
    return this.http.post<AIChatHistory>(`@api/ai/advance/chat/`, payload)
  }

  getChatHistory(chatId: string) {
    return this.http.get<AIChatHistory>(`@api/ai/advance/chat/${chatId}/`)
  }

  getAllChats() {
    return this.http
      .get<{ chats: AIChatItem[] }>(`@api/ai/advance/chats/`)
      .pipe(map(({ chats }) => lodash.sortBy(chats, (t) => t.updatedAt).reverse()))
  }

  deleteChat(chatId: string) {
    return this.http.delete<AIChatHistory>(`@api/ai/advance/chat/${chatId}/`)
  }

  search(query: string) {
    return this.http.post<{ replies: AIChatMessageItemWithMetadata[] }>(`@api/ai/advance/search/`, { query })
  }

  suggestions(payload: AISuggestionRequestPayload) {
    return this.http
      .post<{ suggestions: { suggestion: string }[] }>(`@api/ai/responder/suggestions`, payload)
      .pipe(map((res) => res.suggestions.map((s) => s.suggestion)))
  }

  generateGuestSummary(inquiryId: string): Observable<AiGuestSummaryResponse> {
    return this.http.post<AiGuestSummaryResponse>(`@api/ai/responder/summaries/generate`, { inquiryId, convert: 'html' })
  }
}
